import useSettingsService from 'components/hooks/useSettingsService';
import { SettingValues } from '@linearb/linjs-common';

const useInvestmentCarvingSetting = () => {
  const { getSettingOrDefinitionValue, updateSetting } = useSettingsService();
  const value = getSettingOrDefinitionValue({
    name: SettingValues.INVESTMENT_CARVING
  });

  const onSave = async settingPayload =>
    await updateSetting(SettingValues.INVESTMENT_CARVING, settingPayload);

  const onDelete = async () =>
    await updateSetting(SettingValues.INVESTMENT_CARVING, null);

  return {
    value,
    onSave,
    onDelete
  };
};

export default useInvestmentCarvingSetting;
